import { FormattedMessage } from 'react-intl';
import * as React from 'react';

export const messages = {
  DELETE_ERROR: <FormattedMessage id="delete-error" defaultMessage="Failed to delete signing session" />,
  RESEND_ERROR: <FormattedMessage id="resend-error" defaultMessage="Failed to resend document(s)" />,
  DOWNLOAD_ERROR: <FormattedMessage id="download-error" defaultMessage="Failed to download document(s)" />,
  NO_SIGNING_SESSIONS: <FormattedMessage id="no-signing-sessions" defaultMessage="You have no signing sessions yet." />,
  START_SIGNING: <FormattedMessage id="start-signing" defaultMessage="Start Signing" />,
  STARTED_AT: <FormattedMessage id="started-at" defaultMessage="Started" />,
  COMPLETED: <FormattedMessage id="card-completed" defaultMessage="Completed" />,
  VIEWED: <FormattedMessage id="card-viewed" defaultMessage="Viewed" />,
  NOT_VIEWED: <FormattedMessage id="card-not-viewed" defaultMessage="Not Viewed" />,
  TITLE: <FormattedMessage id="title" defaultMessage="Title" />,
  MESSAGE: <FormattedMessage id="message" defaultMessage="Message" />,
  CLOSE: <FormattedMessage id="close" defaultMessage="Close" />,
  EMPTY_EMAIL_BODY: <FormattedMessage id="empty-email-body" defaultMessage="(empty)" />,
  PAYMENT_ERROR: <FormattedMessage id="payment-error" defaultMessage="Failed to process payment" />,
  GET_PAYMENT_ERROR: <FormattedMessage id="get-payment-error" defaultMessage="Failed to get payments" />,
  GET_CC_ERROR: <FormattedMessage id="get-creditcard-error" defaultMessage="Please add a valid Credit card" />,
  ERROR_DELETE_CARD: <FormattedMessage id="get-creditcard-delete-error" defaultMessage="Credit Card could not be removed" />,
};
